import {columnObjectAlignCenter, columnObjectAlignLeft} from '@utils/tableHelpers';
import {convertToInt} from '@utils/helpers';

export const Columns = {
    'id': {
        label: 'ID',
        sorting: (row) => (row.id ? convertToInt(row.id) : 0),
        ...columnObjectAlignCenter,
    },
    'name': {
        label: 'Name',
        sorting: true,
        ...columnObjectAlignLeft,
    },
    'url': {
        label: 'URL',
        sorting: true,
        ...columnObjectAlignLeft,
    },
    'content': {
        label: 'Content',
        ...columnObjectAlignLeft,
    },
    'actions': {
        label: 'Actions',
        ...columnObjectAlignCenter,
    },
};
